<nb-card [ngStyle]="{ width: settings.cssWidth || '600px' }">
  <nb-card-header *ngIf="settings?.headerIcon || settings?.title">
    <nb-icon *ngIf="settings.headerIcon" icon="{{ settings.headerIcon }}"></nb-icon>
    {{ settings.title }}
  </nb-card-header>
  <nb-card-body>
    <div class="app-form-dialog-container">
      <div *ngIf="settings?.content" style="margin-bottom: 2rem">
        {{ settings?.content }}
      </div>
      <div *ngIf="settings?.contentHtml" [innerHTML]="settings?.contentHtml" style="margin-bottom: 2rem"></div>
      <div class="row row-field" *ngFor="let field of settings.fields">
        <div class="col col-sm-4 col-12">
          <div class="title">
            {{ field.title }}
          </div>
        </div>
        <div class="col col-sm-8 col-12">
          <ng-container [ngSwitch]="field.type || FieldType.STRING">
            <!-- COMBOBOX --------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.COMBOBOX">
              <nb-select
                placeholder="Select {{ field?.title }}"
                [disabled]="field.disabled"
                [selected]="displayData[field.name]"
                [(ngModel)]="displayData[field.name]"
                (ngModelChange)="onFieldValueChange($event, field)"
              >
                <nb-option *ngFor="let r of field.data" [value]="r.value">
                  {{ r.title }}
                </nb-option>
              </nb-select>
            </ng-container>
            <!-- GENDER ----------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.GENDER">
              <nb-radio-group [(value)]="displayData[field.name]">
                <nb-radio value="1">Male</nb-radio>
                <nb-radio value="0">Female</nb-radio>
              </nb-radio-group>
            </ng-container>
            <!-- DATE ------------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.DATE">
              <input
                nbInput
                placeholder="{{ field?.title }}"
                [nbDatepicker]="dateTimePicker"
                [(ngModel)]="displayData[field.name]"
                (ngModelChange)="onFieldValueChange($event, field)"
                style="max-width: inherit"
              />
              <nb-datepicker #dateTimePicker></nb-datepicker>
            </ng-container>
            <!-- DATETIME --------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.DATE_TIME">
              <input
                nbInput
                placeholder="{{ field?.title }}"
                [nbDatepicker]="dateTimePicker2"
                [(ngModel)]="displayData[field.name]"
                (ngModelChange)="onFieldValueChange($event, field)"
                style="max-width: inherit"
              />
              <nb-date-timepicker withSeconds #dateTimePicker2></nb-date-timepicker>
            </ng-container>
            <!-- DATE TIME VIEW ONLY ---------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.DATE_TIME_VIEW">
              <input
                type="text"
                nbInput
                fullWidth
                status="basic"
                [disabled]="true"
                [value]="displayData[field.name] | DateCustomPipe: 'yyyy-MM-dd HH:mm:ss'"
              />
            </ng-container>
            <!-- FILE ------------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.FILE">
              <input style="width: 100%" type="file" class="input-file" (change)="onFileSelected($event, field)" />
            </ng-container>
            <!-- FILE AVATAR ------------------------------------------------------------------------------------------>
            <ng-container *ngSwitchCase="FieldType.FILE_AVATAR">
              <div class="d-flex">
                <app-full-size-avatar
                  [avatarUrl]="displayData[field.name] | ImageUrlPipe"
                  [avatarHdUrl]="displayData[getAvatarHdFieldName(field.name)] | ImageUrlPipe"
                  [(file)]="displayData[field.name]"
                  [editable]="true"
                  [frameStyle]="field.format?.avatarFrameStyle || PvsAvatarFrameStyle.ROUND"
                  [ratio]="field.format?.avatarRatio || 3 / 4"
                  [resizeToWidth]="field.format?.avatarResizeToWidth || 1200"
                ></app-full-size-avatar>
              </div>
            </ng-container>
            <!-- FILE ALL IMAGE --------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.FILE_ALL_IMAGES">
              <input
                style="width: 100%"
                type="file"
                accept="image/*"
                class="input-file"
                (change)="onFileSelected($event, field)"
              />
            </ng-container>
            <!-- CHECKBOX --------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.CHECKBOX">
              <div class="checkbox">
                <nb-checkbox [(ngModel)]="displayData[field.name]"> </nb-checkbox>
              </div>
            </ng-container>
            <!-- TEXT_AREA -------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.TEXT_AREA">
              <textarea
                type="text"
                nbInput
                fullWidth
                placeholder="{{ field?.title }}"
                [(ngModel)]="displayData[field.name]"
                (ngModelChange)="onFieldValueChange($event, field)"
                (keypress)="onKeyPress($event, field.name)"
                [disabled]="field.disabled"
                rows="{{ field?.format?.textAreaRows || 5 }}"
              >
              </textarea>
            </ng-container>
            <!-- JSON ------------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.JSON">
              <textarea
                type="text"
                nbInput
                fullWidth
                placeholder="{{ field?.title }}"
                [(ngModel)]="displayData[field.name]"
                (ngModelChange)="onFieldValueChange($event, field)"
                (keypress)="onKeyPress($event, field.name)"
                [disabled]="field.disabled"
                rows="{{ field?.format?.textAreaRows || 5 }}"
              >
              </textarea>
            </ng-container>
            <!-- TEACHER ---------------------------------------------------------------------------------------------->
            <app-user-selection
              *ngSwitchCase="FieldType.TEACHER"
              [getAllUsersForAdmin]="false"
              [(userId)]="displayData[field.name]"
              (userIdChange)="onFieldValueChange($event, field)"
            ></app-user-selection>
            <!-- ALL USERS -------------------------------------------------------------------------------------------->
            <app-user-selection
              *ngSwitchCase="FieldType.All_USERS"
              [getAllUsersForAdmin]="true"
              [(userId)]="displayData[field.name]"
              (userIdChange)="onFieldValueChange($event, field)"
            ></app-user-selection>
            <!-- PASSWORD ----------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.PASSWORD">
              <input
                type="password"
                nbInput
                fullWidth
                status="basic"
                placeholder="{{ field?.title }}"
                [(ngModel)]="displayData[field.name]"
                (ngModelChange)="onFieldValueChange($event, field)"
                (keypress)="onKeyPress($event, field.name)"
                [disabled]="field.disabled"
              />
            </ng-container>
            <!-- PHONE NUMBER ----------------------------------------------------------------------------------------->
            <ng-container *ngSwitchCase="FieldType.PHONE_NUMBER">
              <input
                type="text"
                appPhoneFormat
                nbInput
                fullWidth
                status="basic"
                placeholder="{{ field?.title }}"
                [(ngModel)]="displayData[field.name]"
                (ngModelChange)="onFieldValueChange($event, field)"
                (keypress)="onKeyPress($event, field.name)"
                [disabled]="field.disabled"
              />
            </ng-container>
            <!-- STRING ----------------------------------------------------------------------------------------------->
            <ng-container *ngSwitchDefault>
              <input
                type="{{ field.type === FieldType.NUMBER ? 'number' : 'text' }}"
                nbInput
                fullWidth
                status="basic"
                placeholder="{{ field?.title }}"
                [(ngModel)]="displayData[field.name]"
                (ngModelChange)="onFieldValueChange($event, field)"
                (keypress)="onKeyPress($event, field.name)"
                [disabled]="field.disabled"
              />
            </ng-container>
          </ng-container>
          <span class="field-error-message">{{ errors[field.name] }}</span>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer *ngIf="buttonType !== ButtonType.NO_BUTTON">
    <div class="text-center" *ngIf="buttonType === ButtonType.OK_ONLY">
      <button nbButton status="info" (click)="onOk()" [disabled]="hasError || sharedService.load">
        <nb-icon icon="checkmark-outline"></nb-icon>OK
      </button>
    </div>
    <div class="text-right" *ngIf="buttonType === ButtonType.OK_CANCEL">
      <button nbButton status="info" (click)="onOk()" [disabled]="hasError || sharedService.load">
        <nb-icon icon="checkmark-outline"></nb-icon>OK
      </button>
      <button nbButton status="basic" (click)="onCancel()"><nb-icon icon="close-outline"></nb-icon>Cancel</button>
    </div>
    <div class="text-right" *ngIf="buttonType === ButtonType.YES_NO">
      <button nbButton status="info" (click)="onOk()" [disabled]="hasError || sharedService.load">
        <nb-icon icon="checkmark-outline"></nb-icon>Yes
      </button>
      <button nbButton status="basic" (click)="onCancel()"><nb-icon icon="close-outline"></nb-icon>No</button>
    </div>
    <div class="text-right" *ngIf="buttonType === ButtonType.YES_NO_10_SECONDS">
      <button
        nbButton
        status="info"
        (click)="onOk()"
        [disabled]="countDownSeconds > 0 || hasError || sharedService.load"
      >
        <nb-icon icon="checkmark-outline"></nb-icon>Yes{{ countDownSeconds > 0 ? ' (' + countDownSeconds + ')' : '' }}
      </button>
      <button nbButton status="basic" (click)="onCancel()"><nb-icon icon="close-outline"></nb-icon>No</button>
    </div>
  </nb-card-footer>
</nb-card>
